<div [ngClass]="(globals.isDesktop)?'desktop':'mobile'">
    <div class="loader">
        <!-- <img src="./assets/images/spinner-blue.gif"> -->
        <ng-lottie #svgAnimationItem_1 [options]="lottieConfig" [width]="'390px'"
                   [height]="'375px'"></ng-lottie>
    </div>
</div>
